import {Observable} from 'rxjs';
import {CpmCRouteResourceApiModel} from '../../models/c-global/cpmc-route-resource.api-model';
import {CpmCApiBridge} from '../../../../../src/app/cpmc-api-bridge';
import {CpmCQueryPaginatorConfig, CpmCQueryPaginatorConfigUtils} from '../../cpmc-defines';
import {ECpmCUserRoleTypeApiEnum} from '../../enums/cpmc-sdk.api-enums';
import {AllowedQueryParamTypes, QueryParams} from '../../../../../sdk/src/utils/query.utils';
import {CpmCPaginatedResultAPISchema} from '../../schemas/cpmc-paginated-result.api-schemas';

export type CpmCGetRouteResourceListParams = {
    [K in keyof CpmCRouteResourceApiModel]?: CpmCRouteResourceApiModel[K] extends AllowedQueryParamTypes
        ? CpmCRouteResourceApiModel[K]
        : never;
} & {forUserRoleType?: ECpmCUserRoleTypeApiEnum} & QueryParams;

/**
 * RouteResource Api Service
 */
export class CpmCRouteResourceApiService {
    public static readonly dPaginatorConfig: CpmCQueryPaginatorConfig = {limit: -1, sort: 'endpoint', order: 1};

    // ===============================================================
    // ===============================================================

    public static baseUrl() {
        return CpmCApiBridge.getBackendBaseURL() + '/api/core/v1/route-resource';
    }

    // ===============================================================
    // ===============================================================

    public static endpointList(): string {
        return `${CpmCRouteResourceApiService.baseUrl()}/list`;
    }

    // ===============================================================
    // ===============================================================

    public static getRouteResourceList(
        params: CpmCGetRouteResourceListParams = {},
        paginatorConfig: CpmCQueryPaginatorConfig = CpmCRouteResourceApiService.dPaginatorConfig
    ): Observable<CpmCPaginatedResultAPISchema<CpmCRouteResourceApiModel>> {
        return CpmCApiBridge.httpGet<CpmCPaginatedResultAPISchema<CpmCRouteResourceApiModel>>(
            CpmCRouteResourceApiService.endpointList(),
            {
                ...(params as QueryParams),
                ...CpmCQueryPaginatorConfigUtils.toQueryParams(paginatorConfig)
            }
        );
    }
}
